module.exports = __webpack_public_path__ + "media/img/pages/profile/hug fr 3-1674270f807acefc213e6c7fc9cf5d62.jpg";